module.exports = __webpack_public_path__ + "img/wealth_of_knowledge.446071c9.svg";